import { apiSlice } from "@app/api/apiSlice";

export const rolesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllRoles: builder.mutation({
      query: (query) => `role/role?&${query}`,
    }),
    loadOneRoleDetails: builder.mutation({
      query: (id) => `role/role/${id}`,
    }),
    saveRole: builder.mutation({
      query: (body) => ({
        url: "role/role",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadAllRolesMutation,
  useLoadOneRoleDetailsMutation,
  useSaveRoleMutation,
} = rolesApiSlice;
